import { useNotification } from '../../../../../../hooks'
import { patchMockApplicant } from '../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import {
  ApplicantResponsibleManagerModal,
  getApplicantResponsibleManagerInitialValues,
} from '../../ApplicantResponsibleManagerModal'

export function useApplicantProfileHeaderInfoItems() {
  const {
    applicantData,
    applicantId,
    handleCloseModal,
    handleEntityReload,
    setModal,
  } = useApplicantProfileContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleSaveFollowUp(nextValue) {
    try {
      await patchMockApplicant(applicantId, { follow_up: nextValue })
      await handleEntityReload()

      handleAddSuccessNotification('Notification.CommonTitleSavedKey')
    } catch (error) {
      handleAddErrorNotification(
        'RentalPortal.ApplicantProfileFollowUpSaveErrorKey'
      )

      throw error
    }
  }

  function handleSaveResponsibleManager() {
    handleCloseModal()

    return handleEntityReload()
  }

  function handleOpenResponsibleManagerModal() {
    setModal(
      <ApplicantResponsibleManagerModal
        applicantId={applicantId}
        initialValues={getApplicantResponsibleManagerInitialValues(
          applicantData?.responsible_manager
        )}
        onClose={handleCloseModal}
        onSave={handleSaveResponsibleManager}
      />
    )
  }

  return { handleOpenResponsibleManagerModal, handleSaveFollowUp }
}
